import { Component, DebugElement, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from '../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { ActivatedRoute, Router } from "@angular/router";
import { AppConfigService } from 'src/app/shared/service/app-config.service';
import { getISOWeek,startOfMonth,endOfMonth } from 'date-fns';
import { LayoutComponent} from'src/app/layout/layout.component';
@Component({
  selector: 'app-wmsm-StatementabnormalWHQ',
  templateUrl: './wmsm-StatementabnormalWHQ.component.html',
  styleUrls: ['./wmsm-StatementabnormalWHQ.component.scss']
})
export class WmsmStatementAbnormalWHQComponent extends BaseComponent implements OnInit {
  loading: boolean = false;
  isShowCondition: boolean = true;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  listOfData: any[] = [];
  validateForm: FormGroup;
  VendorCode:any[];
  formValues: any;
  tw:boolean;
  cn:boolean;
  en:boolean;

  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private Environment: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private router: Router,
    private LayoutComponent:LayoutComponent,
    private ConfigService: AppConfigService
  ) { super() }

  ngOnInit() {
    this.matomotracker.trackPageView("供應商管理")
    this.matomotracker.trackEvent("供應商管理","TW對賬單異常","Transation",1);
    this.validateForm = this.fb.group({
      PONO: [''],
    });
    this.LayoutComponent.geturl()
  }
  getFormValue(value) {
    this.formValues = value;
  }

  getQuery(value) {
    this.isShowCondition = value;
  }
  onSearch() {

    this.getResultData()
  }
  // 获取查询表格数据
  getResultData() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.AbnormalQuery.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        PoNo: this.formValues.PONO,
        buyer: this.formValues.Buyer,
        siteNo:this.formValues.Site,
        VendorCode: this.formValues.Vendor,
      },
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (
          res.length  !== 0
        ) {
          this.listOfData = res.data.map((item) => {
            item.invoiceDate = DateUtil.formatYMD(item.invoiceDate);
            item.returnDate = DateUtil.formatYMD(item.returnDate);

            return item;
          });
          this.nzTotal = res.total;
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
        }
        var value: any; 
       value=this.listOfData;
       if(value==''||value==null )
    {
      let language=sessionStorage.getItem("wmsmlang");
      if(language=='zh-TW'){
        this.NzMessageService.success('該選擇條件下沒有異常信息');
      }
      if(language=='zh-CN'){
        this.NzMessageService.success('该选择条件下没有异常信息');
      }
      if(language=='en'){
        this.NzMessageService.success('There is no exception information under this selection condition');
      }
      this.GetLanguage();
      this.loading = false;
      return;
    }
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false;
      }
    );
    this.loading = false;
  }

  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }
  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }


  GetLanguage(){
    if(sessionStorage.getItem("wmsmlang")=="zh-CN"){
      this.cn=true;
      this.tw=false;
      this.en=false;
    }
    if(sessionStorage.getItem("wmsmlang")=="zh-TW"){
      this.tw=true;
      this.cn=false;
      this.en=false;
    }
    if(sessionStorage.getItem("wmsmlang")=="en"){
      this.en=true;
      this.cn=false;
      this.tw=false;
    }

  }


  sortChange(e) {

    this.listOfData = e === 'ascend' ? this.listOfData.sort(
      (a, b) => a.poNo.localeCompare(b.poNo)
    ) : this.listOfData.sort(
      (a, b) => b.poNo.localeCompare(a.poNo)
    )
  }

  sortChange1(e) {

    this.listOfData = e === 'ascend' ? this.listOfData.sort(
      (a, b) => a.invoiceNo.localeCompare(b.invoiceNo)
    ) : this.listOfData.sort(
      (a, b) => b.invoiceNo.localeCompare(a.invoiceNo)
    )
  }

  onQueryClick1():string{
    return 'StatementabnormalWHQ';
  }

  DownloadQueryStatementAbnormalExcel() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownloadQueryStatementAbnormalExcel.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        PoNo: this.formValues.PONO,
        buyer: this.formValues.Buyer,
        siteNo:this.formValues.Site,
        VendorCode: this.formValues.Vendor,
      },
    };
    this.WebApiService.doPost(url, params, true).subscribe((res) => {
      this.NzMessageService.success('下载成功');
      this.downloadFile8(res, `TWN_Abnormal_Payment_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }
}
